const styles = theme => ({
    root: {
        flexGrow: 1
    },
    grow: {
        flexGrow: 1,
    },
    main: {
        // marginTop: "25px"
    },
    container: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        paddingTop: "30px",
        paddingBottom: "20px",
    },
    toolBar: {
        paddingLeft: "0px",
        paddingRight: "0px",
        fontWeight: 700,
    },
    listContainer: {
        marginTop: "40px",
    },
    listItem: {
        backgroundColor: theme.palette.action.hover,
    },
    del_button: {
        border: `2px solid ${theme.palette.error.main}`,
        backgroundColor: theme.palette.error.main,
        color: theme.palette.getContrastText(theme.palette.error.main),
        padding: "14px 28px",
        fontsize: "16px",
        cursor: "pointer",

    }
});

export default styles;
